import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import { type FaqCategory } from './functions/orderFaqCategories';
import Image from 'next/image';
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';
import ChevronRightIcon from '@/assets/icons/heroIcons/Chevron-right.svg';
interface Props {
  category: FaqCategory;
  name: string;
  icon: ReactNode;
}
export function GroupedCategory(props) {
  const $ = _c(12);
  const {
    category,
    icon,
    name
  } = props;
  let t0;
  if ($[0] !== name) {
    t0 = <h2 className="text-2xl font-bold md:text-3xl"> {name}</h2>;
    $[0] = name;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== icon || $[3] !== t0) {
    t1 = <div className="mb-8 flex flex-col items-center gap-2 md:flex-row md:gap-4">{icon}{t0}</div>;
    $[2] = icon;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== category) {
    t2 = category.map(_temp);
    $[5] = category;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className="flex flex-col gap-2">{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <section className="rounded-4xl bg-white px-6 py-6 md:px-8 md:py-10">{t1}{t3}</section>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function _temp(item) {
  if (!item || !item.slug) {
    return null;
  }
  return <Link analyticsParam={`faqCategory${item._id}`} testId={`faqCategory${item._id}`} to={LINKS().faqCategory(item.slug.current || "")} key={item._id} className="flex items-center gap-2 py-2 text-gray-900 no-underline hover:text-gray-900">{item.icon && item.icon.asset?.url && <Image width={28} height={28} src={item.icon.asset.url} alt={item.name || ""} />}<h3 className="font-semibold">{item.name}</h3><ChevronRightIcon className="ml-auto text-blue-500" /></Link>;
}